import React from 'react';
import { motion } from 'framer-motion';
import { PublicLayout } from '../../components/layout/PublicLayout';
import { SEOMetaTags } from '../../components/shared/SEOMetaTags';

// Icônes (optionnel pour plus tard)
import { Linkedin, Mail } from 'lucide-react';

// --- Données de l'équipe AVEC LES LIENS D'IMAGES DE L'ANCIEN SITE ---
const teamMembers = [
    {
        name: 'M. Yves .A. FOFIE',
        title: 'Président du Comité Consultatif',
        description: 'Expert en Gouvernance et Lutte Contre la Corruption. Membre Conseil / ADM / ACAADA MALAWI. Administrateur Associé cabinet 2AY-FRANCE.',
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2024/07/f023c490-9d9f-479c-9773-48de3b2b0e60.jpg',
    },
    {
        name: 'Dr KAH Evans',
        title: 'Coordonnateur - Jury ICE',
        description: 'Anthropologue & Chargé de Cours à l\'Université de Yaoundé I.',
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2022/08/DR-KAH-new.jpg',
    },
    {
        name: 'M. IBRAHIM N. ANGLOMA',
        title: 'Vice-Président du Comité Consultatif',
        description: 'Agent de Footballeurs & Représentant ICE France / Europe.',
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2024/08/aa6d96dc-02fe-4094-95cf-039315da59a0.jpg',
    },
    {
        name: 'Dr HAMILTON HENRY CASTRO',
        title: 'Responsable Pôle Médiation',
        description: 'Médiateur Universel & Directeur de la Fondation Posconflicto.org, Colombie.',
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2021/07/dr-hamilton-new-1.jpg',
    },
    {
        name: 'Fabien NKILI NDEMEZOHO',
        title: 'Représentant ICE - Gabon',
        description: 'Directeur Adjoint de la Promotion de la Bonne Gouvernance au Ministère dédié.',
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2024/01/fab.jpg',
    },
    {
        name: 'M. PAULIN ENAMA',
        title: 'Vice-Président du Jury',
        description: 'Administrateur Civil.',
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2022/12/paulin-enama.jpg',
    },
    {
        name: 'Mme SONKBOU EPSE TCHINDA',
        title: 'Chargée de Missions Afrique Centrale & Australe',
        description: 'Coordonne les activités et le déploiement dans la région.',
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2023/10/joelle-chef-cab-2.jpg',
    },
    {
        name: 'M. SNEY WATINOU',
        title: 'Chargé de Missions ICE - Congo',
        description: 'Sociologue et coordinateur des initiatives locales.',
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2024/07/9742acbf-4a75-4c22-abe1-280b6acc0b81DDDD.jpg',
    },
    {
        name: 'Dr OUMAROU BEKAMBA',
        title: 'S-Exécutif & Chef du département projets',
        description: 'Dirige la conception et la mise en œuvre des programmes de l\'ICE.',
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2024/01/OUM-1-1024x1024.jpg',
    },
];

export const TeamPage: React.FC = () => {
    return (
        <PublicLayout>
            <SEOMetaTags 
                title="Notre Équipe - International Committee of Excellence (ICE)"
                description="Découvrez les experts, coordinateurs et représentants qui composent l'équipe de l'ICE et portent nos valeurs à travers le monde."
            />

            <div className="bg-[#0d1321] text-white">

                {/* --- Section Héros --- */}
                <section 
                    className="relative py-32 md:py-48 flex items-center justify-center text-center"
                    style={{
                        backgroundImage: 'url(https://ice-inter.com/wp-content/uploads/2021/09/c.const-fot-famill-768x576.jpg)',
                        backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed'
                    }}
                >
                    <div className="absolute inset-0 bg-[#0d1321]/80 backdrop-blur-sm"></div>
                    <div className="relative z-10 container mx-auto px-4">
                        <motion.h1 
                            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
                            className="text-4xl md:text-6xl font-bold text-white mb-4"
                        >
                            Les Visages de l'<span className="text-[#d2ab6a]">Excellence</span>
                        </motion.h1>
                        <motion.p 
                            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }}
                            className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto"
                        >
                            Notre organisation est portée par une équipe d'experts et de leaders passionnés, engagés pour la promotion du mérite et de l'intégrité en Afrique.
                        </motion.p>
                    </div>
                </section>

                {/* --- Grille de l'Équipe --- */}
                <section className="py-20">
                    <div className="container mx-auto px-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
                            {teamMembers.map((member, i) => (
                                <motion.div
                                    key={member.name}
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.6, delay: i * 0.1 }}
                                    className="group bg-white/5 rounded-2xl overflow-hidden border border-white/10 transition-all duration-300 hover:border-[#d2ab6a]/50 hover:bg-white/10 transform hover:-translate-y-2"
                                >
                                    <div className="relative h-80 bg-white/5">
                                        <img 
                                            src={member.imageUrl} 
                                            alt={`Portrait de ${member.name}`} 
                                            className="w-full h-full object-cover object-center transition-transform duration-300 group-hover:scale-105"
                                            // Ajout d'un onError pour gérer les images qui pourraient être cassées
                                            onError={(e) => {
                                                const target = e.target as HTMLImageElement;
                                                target.onerror = null; // prévient une boucle infinie
                                                target.src = 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?fit=crop&w=800&q=80'; // Image de secours
                                            }}
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-[#0d1321]/50 via-transparent"></div>
                                    </div>
                                    <div className="p-6">
                                        <h3 className="text-2xl font-bold text-white">{member.name}</h3>
                                        <p className="text-[#d2ab6a] font-semibold text-md mb-4">{member.title}</p>
                                        <p className="text-white/70 text-sm leading-relaxed">
                                            {member.description}
                                        </p>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        </PublicLayout>
    );
};

export default TeamPage;